import React from "react";
import { DateTime } from "luxon";

const EventCard = ({ event }) => {
	const startTime = DateTime.fromSeconds(event.start?.timestamp || 0);
	const endTime = DateTime.fromSeconds(event.end?.timestamp || 0);

	const formatDate = dateTime => {
		const now = DateTime.now();
		if (dateTime.hasSame(now, "day")) {
			return "Today";
		} else if (dateTime.hasSame(now.plus({ days: 1 }), "day")) {
			return "Tomorrow";
		} else {
			return dateTime.toFormat("MMM d");
		}
	};

	// Get the day number for the calendar icon
	const dayNumber = startTime.toFormat("d");

	return (
		<div style={styles.eventCard}>
			<div style={styles.cardHeader}>
				<div style={styles.calendarIcon}>
					<img src={`https://ssl.gstatic.com/calendar/images/dynamiclogo_2020q4/calendar_${dayNumber}_2x.png`} alt="Calendar" style={styles.calendarImage} />
				</div>
				<div style={styles.dateTimeInfo}>
					<div style={styles.dateText}>{formatDate(startTime)}</div>
					<div style={styles.timeText}>
						{startTime.toFormat("HH:mm")} - {endTime.toFormat("HH:mm")}
					</div>
				</div>
			</div>

			<h3 style={styles.title}>{event.title}</h3>

			<div style={styles.attendeesInfo}>
				<img src="./invitees.png" alt="Invitees" style={styles.inviteesIcon} />
				<span style={styles.attendeesText}>{event.attendees?.length || 0} Attendees</span>
			</div>

			<div style={styles.actions}>
				<button style={styles.detailsBtn}>Details</button>
				{event.meetingLink ? (
					<a href={event.meetingLink} target="_blank" rel="noreferrer" style={styles.joinBtn}>
						Join
					</a>
				) : (
					<button style={styles.joinBtn}>Join</button>
				)}
			</div>
		</div>
	);
};

const styles = {
	eventCard: {
		background: "linear-gradient(to right, rgb(216 220 244 / 22%), rgb(196 214 255 / 22%))",
		borderRadius: "16px",
		padding: "0.25rem",
		backdropFilter: "blur(10px)",
		border: "1px solid rgba(255, 255, 255, 0.1)",
		minHeight: "200px",
		color: "white",
		display: "flex",
		flexDirection: "column",
		width: "320px",
		minWidth: "320px",
		flexShrink: 0,
	},

	cardHeader: {
		display: "flex",
		alignItems: "center",
		gap: "0.5rem",
		marginBottom: "2rem",
		paddingLeft: "0.25rem",
		paddingTop: "0",
		marginTop: "0.25rem",
	},

	calendarIcon: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},

	calendarImage: {
		width: "32px",
		height: "32px",
		objectFit: "contain",
	},

	dateTimeInfo: {
		display: "flex",
		flexDirection: "column",
	},

	dateText: {
		fontSize: "0.875rem",
		color: "white",
		fontWeight: "bold",
	},

	timeText: {
		fontSize: "12px",
		color: "rgba(255, 255, 255)",
		fontWeight: "300",
	},

	title: {
		fontSize: "24px",
		fontWeight: "600",
		margin: "0 0 0.25rem 0", // Reduced bottom margin from 0.75rem to 0.25rem
		color: "white",
		lineHeight: "1.3",
		paddingLeft: "42px",
	},

	attendeesInfo: {
		display: "flex",
		alignItems: "center",
		gap: "0.5rem",
		marginBottom: "1.5rem",
		fontSize: "0.875rem",
		color: "rgba(255, 255, 255, 0.8)",
		paddingLeft: "42px", // Changed from 1.5rem to 42px to match title padding exactly
	},

	inviteesIcon: {
		width: "16px",
		height: "16px",
		objectFit: "contain",
	},

	attendeesText: {
		fontSize: "12px",
		fontWeight: "400",
	},

	actions: {
		display: "flex",
		gap: "0.75rem",
		marginTop: "auto",
		justifyContent: "flex-end",
		paddingRight: "0.5rem",
		paddingBottom: "0.5rem",
	},

	detailsBtn: {
		borderRadius: "11px",
		border: "1px solid rgba(255, 255, 255, 0.3)",
		background: "transparent",
		color: "white",
		fontSize: "12px",
		cursor: "pointer",
		transition: "all 0.2s ease",
		fontFamily: "inherit",
		fontWeight: "400",
		":hover": {
			background: "rgba(255, 255, 255, 0.1)",
		},
		height: "28px",
		width: "78px",
	},

	joinBtn: {
		borderRadius: "11px",
		border: "none",
		background: "#ffffff",
		color: "#465C9E",
		fontSize: "12px",
		cursor: "pointer",
		transition: "all 0.2s ease",
		textDecoration: "none",
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		fontFamily: "inherit",
		fontWeight: "400",
		":hover": {
			background: "#f9fafb",
		},
		height: "28px",
		width: "78px",
	},
};

export default EventCard;
